import { init } from '@plantquest/frontend/src/init'
let aws = {}
try {
  const awsContext = require.context('.', false, /aws-exports(\.js)?$/)
  const awsPath = awsContext
    .keys()
    .find(function (key) {
      return key === './aws-exports' || key === './aws-exports.js'
    })

  if (awsPath) {
    const awsModule = awsContext(awsPath)
    aws = awsModule.default || awsModule
  } else {
    console.warn('No aws-exports file found, continuing without Amplify config.')
  }
} catch (error) {
  console.warn('Unable to load aws-exports, continuing without Amplify config.', error)
}
//import td from '../../data/deploy/bausch/waterford.bausch/map_json_db/bl-wf01-ast-012.json' 
//import td from '../../data/deploy/bausch/waterford.bausch/map_json_db/bl-wf01-ast-013.2.json' 
//import td from '../../data/deploy/prd/map_json_db/pqd-pq01-ast-026.json' 
//import defaultTd from '../../data/deploy/prd/map_json_db/pqd-pq01-ast-025.json'
//import defaultTd from '../../data/deploy/jnj/biocork/map_json_db/jn-ry-ast-014.7.2.5.json'
import mixpanel from 'mixpanel-browser'
// Import Navvis Z-coordinate utility
import './utils/navvisZCoordinate'

function initializeMixpanel() {
  try {
    mixpanel.init('ffc5caf02d86aa22d5db7dfc2b128fff', {
      debug: true,
      api_host: 'https://api-eu.mixpanel.com',
      track_pageview: true,
      persistence: 'localStorage',
      secure_cookie: true,
      cookie_domain: '.plantquest.app',
    });
    console.log('Mixpanel initialized successfully-system-demo.');
  } catch (error) {
    console.error('Error initializing Mixpanel-system-demo.:', error);
  }
}


// Initialize td with a default value
//let td = defaultTd;
let td = {};
//pause and try to load the configured map if available


import model from '../model/model.json'
// lets load dotenv
import dotenv from 'dotenv'
//.env vars are up a level

// Load environment variables in order of precedence
dotenv.config({ path: '../.env.main' })
dotenv.config() // Load default .env if exists

// Client bundle only receives VUE_APP_* from webpack (see vue.config.js). DEPLOY_ENV is build-time only in Node.
const deployEnv =
  process.env.VUE_APP_DEPLOY_ENV || process.env.DEPLOY_ENV || 'dev'

// Load environment-specific variables (Node/dev only; production uses values baked at build time)
const envFile = `../../.env.${deployEnv}`
dotenv.config({ path: envFile })

console.log('Environment:', deployEnv)
console.log('Environment file:', envFile)
console.log('CloudFront Distribution:', process.env.VUE_APP_CLOUDFRONT_DISTRIBUTION)

console.log('D02', deployEnv, process.env.VUE_APP_CLOUDFRONT_DISTRIBUTION)

console.log('process.env.MAP_JSON_FILE', process.env.MAP_JSON_FILE)



td.assets = []

document.title = process.env.VUE_APP_TITLE || 'PlantQuest';

let env_file = `.env.${deployEnv}`
dotenv.config({ path: env_file })
console.log('env_file', env_file)

console.log('map_height', process.env.VUE_APP_MAP_HEIGHT || process.env.MAP_HEIGHT)

const info = {
  node_env: process.env.NODE_ENV,
  auth_mode: 'seneca',
  VUE_APP_CLOUDFRONT_DISTRIBUTION: process.env.VUE_APP_CLOUDFRONT_DISTRIBUTION,
  app: {
    system: 'demo',
    name: 'admwa01',
    version: '0.5.0',
    note: process.env.VUE_APP_NOTE || "",
  },
  PqsFrontend: init.info,
}
console.log('!!!td', td)
td.rooms = []

const hostname = window.location.hostname;
const baseUrl = hostname === 'localhost' 
? `http://${hostname}:9204` 
: `https://${hostname}`;


// Field lists are defined once in @plantquest/frontend/src/config/fieldConfig.js.
// They fall back to defaults mirroring the backend asset_fieldmap.ts, and can
// be overridden per-site via VUE_APP_ASSET_FIELDS / VUE_APP_ROOM_FIELDS in .env.
import { ASSET_QUERY_FIELDS as assetFields, ROOM_QUERY_FIELDS as roomFields } from '@plantquest/frontend/src/config/fieldConfig'

// On the OIDC callback page there is no session yet. The Promise.all fetches
// will get 401 but are caught individually and fall back to empty data, so
// initPlantQuest() still fires. The critical guard is in init.js which skips
// load_current_user on /callback (preventing the 44444ms seneca timeout).

// Load both rooms and assets from Seneca endpoints (replacing direct DynamoDB calls)
Promise.all([
  // Get rooms (assets with atype = 'Room/Area')
  fetch(baseUrl+'/api/private/msg01', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      "cmd": "list",
      "q": {
        "atype": "Room/Area",
        "building$": { "$ne": null },
        "map$": { "$ne": null },
        "level$": { "$ne": null },
        "poly$": { "$exists": true, "$ne": null },
        "tag$": { "$ne": null },
        "fields$": roomFields
      },
      "qent": {
        "entity$": "-/pqs/asset"
      },
      "sys": "entity",
      "base": "pqs",
      "name": "asset"
    })
  }).then(response => {
    console.log('Rooms response status:', response.status);
    console.log('Rooms response headers:', response.headers);
    return response.json();
  }).then(data => {
    console.log('Rooms response data:', data);
    return data;
  }).catch(error => {
    console.error('Rooms fetch error:', error);
    return { data: [] };
  }),
  
  // Get all assets
  fetch(baseUrl+'/api/private/msg01', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      "cmd": "list",
      "tag$": { "$ne": null },         // Exclude assets where tag is null
      "q": {
        "fields$": assetFields
      },
      "qent": {
        "entity$": "-/pqs/asset"
      },
      "sys": "entity",
      "base": "pqs",
      "name": "asset"
    })
  }).then(response => {
    console.log('Assets response status:', response.status);
    return response.json();
  }).then(data => {
    console.log('Assets response data:', data);
    return data;
  }).catch(error => {
    console.error('Assets fetch error:', error);
    return { data: [] };
  })
])
  .then(([roomResponse, assetResponse]) => {
    console.log('Full roomResponse:', roomResponse);
    console.log('Full assetResponse:', assetResponse);
    
    // Try different possible response structures
    let allRooms = roomResponse.data || roomResponse || [];
    td.assets = assetResponse.data || assetResponse || [];
    td.levels = []
    
    // Filter rooms to only include those with valid polygon data
    td.rooms = allRooms.filter(room => {
      const hasValidPoly = room.poly && 
                          Array.isArray(room.poly) && 
                          room.poly.length > 0 &&
                          room.poly.some(point => Array.isArray(point) && point.length >= 2);
      
      if (!hasValidPoly) {
        console.log(`Filtering out room without valid poly: ${room.tag || room.id}`, room.poly);
      }
      
      return hasValidPoly;
    });
    
    console.log('td.rooms (filtered):', td.rooms);
    console.log('td.assets', td.assets);
    console.log('Loaded rooms from Seneca:', td.rooms.length, 'rooms (filtered from', allRooms.length, 'total)');
    console.log('Loaded assets from Seneca:', td.assets.length, 'assets');

    // Debug: Check what level data we have
    console.log('Sample asset data:', td.assets.slice(0, 2));
    console.log('Sample room data:', td.rooms.slice(0, 2));

    // Generate deps dynamically after rooms and assets are loaded
    td.deps = generateDeps(
      td.assets || [], 
      td.rooms, 
      td.maps || [], 
      td.buildings || [], 
      td.levels || []
    );
    
    console.log('Generated deps:', td.deps);
    
    // Debug: Check map~building~level relationships specifically
    if (td.deps.pc && td.deps.pc['map~building~level']) {
      console.log('map~building~level relationships:', Object.keys(td.deps.pc['map~building~level']));
      console.log('Sample map~building~level data:', Object.keys(td.deps.pc['map~building~level']).slice(0, 5).map(key => ({
        key,
        rooms: td.deps.pc['map~building~level'][key]?.room || []
      })));
    } else {
      console.log('WARNING: No map~building~level relationships found in deps.pc');
    }
    
    // Extract and populate levels, maps, and buildings from deps
    td.levels = extractLevelsFromDeps(td.deps);
    console.log('Extracted levels:', td.levels);
    
    td.maps = extractMapsFromAssets(td.assets);
    console.log('Extracted maps:', td.maps);

    td.buildings = extractBuildingsFromDeps(td.deps);
    td.buildings.push('Dynamic Test Building');
    console.log('Extracted buildings:', td.buildings);

    // search data.rooms for 'PQ ROOM 2 21'
    const room = td.rooms.find(room => room.room === 'PQ ROOM 2 21');
    console.log('Test room:', room);

    // Initialize the PlantQuest frontend after deps are generated
    initPlantQuest();
  })
  .catch(error => {
    console.error('Error fetching data:', error);
    td.rooms = [];
    td.assets = [];
    
    // Generate deps even if data loading fails
    td.deps = generateDeps(
      td.assets || [], 
      td.rooms, 
      td.maps || [], 
      td.buildings || [], 
      td.levels || []
    );
    
    console.log('Generated deps (fallback):', td.deps);
    
    // Extract levels, maps, and buildings from deps
    td.levels = extractLevelsFromDeps(td.deps);
    console.log('Extracted levels (fallback):', td.levels);
    
    td.maps = extractMapsFromAssets(td.assets);
    console.log('Extracted maps (fallback):', td.maps);
    
    td.buildings = extractBuildingsFromDeps(td.deps);
    console.log('Extracted buildings (fallback):', td.buildings);
    
    // Initialize the PlantQuest frontend
    initPlantQuest();
  });
//jn-rsky-m01-004

let custom = {
  navvis_map_data: [{"map_1_9053":{"bounds":[5064,5119,5064,5583,4867,5583,4867,5423,4667,5423,4667,5496,4726,5496,4726,5581,4598,5581,4598,5349,4340,5349,4340,5118],"floor_z":44.7,"ceiling_z":56,"map":1},"map_1_2510":{"bounds":[4864,5423,4864,5577,4729,5577,4729,5496,4668,5496,4668,5423],"floor_z":44.7,"ceiling_z":47.9,"map":1},"map_1_1658":{"bounds":[4596,5349,4596,5584,4339,5584,4339,5347],"floor_z":44.7,"ceiling_z":49.2,"map":1},"map_1_4308":{"bounds":[5141,6396,5092,6396,5092,6372,5136,6372,5136,6396,5255,6396,5255,6707,4886,6707,4886,6975,4697,6975,4697,6779,4647,6779,4647,6766,4571,6766,4571,6964,4419,6964,4419,6871,4339,6871,4342,6853,4199,6853,4199,6768,4127,6768,4127,6968,3947,6968,3947,6645,4514,6645,4514,6399,4886,6399,4886,6645,5037,6645,5037,6514,5122,6514,5122,6483,5139,6483],"floor_z":44.7,"ceiling_z":57,"map":1},"map_1_7334":{"bounds":[4514,6398,4514,6645,3947,6645,3947,6398],"floor_z":44.7,"ceiling_z":50.5,"map":1},"map_1_2962":{"bounds":[4415,6871,4415,6968,4128,6968,4128,6772,4198,6772,4198,6851,4339,6851,4339,6873],"floor_z":44.7,"ceiling_z":48.1,"map":1},"map_1_6529":{"bounds":[4697,6782,4697,6967,4569,6967,4569,6765,4648,6765,4651,6779],"floor_z":44.7,"ceiling_z":49.2,"map":1},"map_1_5227":{"bounds":[5136,6396,5136,6481,5121,6481,5121,6511,5037,6511,5037,6644,4886,6644,4886,6396],"floor_z":44.7,"ceiling_z":50.2,"map":1},"map_1_4147":{"bounds":[3732,6630,3732,6684,3659,6684,3659,6826,3632,6826,3632,6689,3561,6689,3561,6634,3595,6634,3595,6589,3658,6589,3658,6632],"floor_z":44.7,"ceiling_z":48,"map":1},"map_1_6685":{"bounds":[3943,6397,3943,6701,3867,6701,3867,6397],"floor_z":44.7,"ceiling_z":48,"map":1},"map_1_5393":{"bounds":[4932,7226,4932,7275,4681,7275,4681,7226],"floor_z":44.7,"ceiling_z":47.9,"map":1},"map_1_5386":{"bounds":[5200,7373,5200,7407,5037,7407,5037,7373],"floor_z":44.7,"ceiling_z":47.9,"map":1},"map_1_3627":{"bounds":[5188,7568,5188,7597,5073,7597,5073,7568],"floor_z":44.7,"ceiling_z":49.1,"map":1},"map_1_5778":{"bounds":[4622,7558,4622,7871,4583,7871,4583,7913,4539,7913,4539,7563],"floor_z":44.7,"ceiling_z":48,"map":1},"map_1_4740":{"bounds":[5064,5119,5064,5583,4867,5583,4867,5423,4667,5423,4667,5496,4726,5496,4726,5581,4598,5581,4598,5349,4340,5349,4340,5118],"floor_z":44.7,"ceiling_z":53.5,"map":1},"map_1_6311":{"bounds":[4180,7561,4180,7920,4133,7920,4133,7561],"floor_z":44.7,"ceiling_z":51.8,"map":1},"map_1_1626":{"bounds":[4065,8057,4065,8106,3849,8106,3849,8026,3888,8026,3888,7966,3973,7966,3973,8055],"floor_z":44.7,"ceiling_z":51.8,"map":1},"map_2_2516":{"bounds":[4594,5348,4594,5585,4338,5585,4338,5348],"floor_z":49.77,"ceiling_z":55.5,"map":2},"map_2_9500":{"bounds":[5183,5120,5183,5189,5194,5186,5194,5588,5066,5588,5066,5120],"floor_z":49.77,"ceiling_z":57,"map":2},"map_2_2860":{"bounds":[4298,4988,4160,4988,4160,4836,4149,4836,4149,4707,4298,4707],"floor_z":49.23,"ceiling_z":54.4,"map":2},"map_2_9403":{"bounds":[4594,4222,4594,4352,4580,4352,4580,4374,4512,4374,4512,4358,4375,4358,4375,4219],"floor_z":48.75,"ceiling_z":54.4,"map":2},"map_2_9912":{"bounds":[4518,4456,4518,4492,4536,4492,4536,4581,4373,4581,4373,4455],"floor_z":49.24,"ceiling_z":54.4,"map":2},"map_2_4014":{"bounds":[4728,4707,4728,4876,4500,4876,4500,4707,4625,4707,4625,4761,4660,4761,4660,4706],"floor_z":48.7,"ceiling_z":54.4,"map":2},"map_2_4298":{"bounds":[5091,4818,5091,4879,4771,4879,4771,4817],"floor_z":48.7,"ceiling_z":54.4,"map":2},"map_2_5454":{"bounds":[5118,4754,5118,4816,4766,4816,4766,4760,4998,4760,4998,4706,5044,4706,5044,4753],"floor_z":47.8,"ceiling_z":54.4,"map":2},"map_2_3258":{"bounds":[5363,4748,5363,4893,5189,4893,5189,4748],"floor_z":49.77,"ceiling_z":54.4,"map":2},"map_2_7412":{"bounds":[4751,4221,4751,4586,4624,4586,4624,4661,5278,4661,5278,4618,5378,4618,5378,4748,5188,4748,5047,4748,5047,4708,4967,4708,4967,4760,4733,4760,4733,4705,4498,4705,4498,4874,4729,4874,4729,4760,4763,4760,4763,4817,4771,4817,4771,4881,5092,4881,5092,4816,5119,4816,5119,4749,5186,4749,5186,4972,4301,4972,4301,4704,4121,4704,4121,4857,3942,4857,3942,4576,4030,4576,4030,4604,4085,4604,4085,4659,4157,4659,4157,4597,4116,4597,4116,4533,4224,4533,4224,4506,4127,4506,4127,4423,4266,4423,4266,4638,4458,4638,4458,4661,4537,4661,4537,4493,4520,4493,4520,4456,4432,4456,4432,4387,4582,4387,4582,4458,4594,4458,4594,4222],"floor_z":47.8,"ceiling_z":54.4,"map":2},"map_2_8234":{"bounds":[3796,4766,3796,4903,3733,4903,3733,4766],"floor_z":49.24,"ceiling_z":54.04,"map":2},"map_2_7695":{"bounds":[3864,4710,3864,4794,3799,4794,3799,4710],"floor_z":49.24,"ceiling_z":52.76,"map":2},"map_2_4795":{"bounds":[3941,4718,3941,4748,3866,4748,3866,4718],"floor_z":49.24,"ceiling_z":54.4,"map":2},"map_2_4544":{"bounds":[5203,7149,5203,7220,5254,7220,5254,7376,5203,7376,5203,7492,5139,7492,5139,7578,5164,7578,5164,7599,5254,7599,5254,7979,4805,7979,4805,7999,4543,7999,4543,7973,4434,7973,4434,7996,4170,7996,4170,7975,4054,7975,4054,7930,4032,7930,4032,7911,3953,7911,3953,7282,4052,7282,4052,7225,4903,7225,4903,7148],"floor_z":47.9,"ceiling_z":53.2,"map":2},"map_2_7016":{"bounds":[5315,7378,5315,7553,5253,7553,5253,7426,5204,7426,5204,7379],"floor_z":49.2,"ceiling_z":51.6,"map":2},"map_2_8386":{"bounds":[4053,7930,4053,7989,3969,7989,3969,8103,3840,8103,3840,8033,3922,8033,3922,7917,3953,7917,3951,7913,4028,7913,4028,7932],"floor_z":49.2,"ceiling_z":52.36,"map":2},"map_2_8608":{"bounds":[4177,7155,4177,7224,4052,7224,4052,7284,3950,7284,3950,7225,3950,7225,4019,7225,4019,7157],"floor_z":49.2,"ceiling_z":52.36,"map":2},"map_2_2787":{"bounds":[4061,7988,4061,8106,3969,8106,3969,8056,4035,8056,4035,7989],"floor_z":49.2,"ceiling_z":53.5,"map":2},"map_2_7516":{"bounds":[5254,7425,5254,7596,5167,7596,5167,7579,5141,7579,5141,7492,5204,7492,5204,7426],"floor_z":49.2,"ceiling_z":52.36,"map":2},"map_2_3423":{"bounds":[4864,5421,4864,5578,4724,5578,4724,5495,4662,5495,4662,5423],"floor_z":48.16,"ceiling_z":51.86,"map":2},"map_2_5089":{"bounds":[5031,5125,5031,5170,4905,5170,4905,5125],"floor_z":47.65,"ceiling_z":56,"map":2},"map_2_6205":{"bounds":[4743,5177,4743,5232,4708,5232,4708,5177],"floor_z":46.6,"ceiling_z":56,"map":2},"map_2_1618":{"bounds":[4687,5179,4687,5234,4651,5234,4651,5179],"floor_z":46.6,"ceiling_z":56,"map":2},"map_2_6572":{"bounds":[4630,5181,4630,5231,4596,5231,4596,5181],"floor_z":46.6,"ceiling_z":56,"map":2},"map_2_7194":{"bounds":[4577,5179,4577,5231,4541,5231,4541,5179],"floor_z":46.6,"ceiling_z":56,"map":2},"map_2_4738":{"bounds":[4520,5181,4520,5232,4485,5232,4485,5181],"floor_z":46.6,"ceiling_z":56,"map":2},"map_2_4230":{"bounds":[4463,5182,4463,5231,4428,5231,4428,5182],"floor_z":46.6,"ceiling_z":56,"map":2},"map_2_2755":{"bounds":[4407,5184,4407,5236,4369,5236,4369,5184],"floor_z":46.6,"ceiling_z":56,"map":2},"map_2_7730":{"bounds":[5183,5120,5183,5189,5194,5186,5194,5588,5066,5588,5066,5120],"floor_z":48.8,"ceiling_z":57,"map":2},"map_2_1155":{"bounds":[4698,6783,4698,6967,4568,6967,4568,6763,4648,6763,4648,6784],"floor_z":49.2,"ceiling_z":57,"map":2},"map_3_6279":{"bounds":[4513,6560,4513,6641,4425,6641,4425,6560],"floor_z":47.5,"ceiling_z":50.5,"map":3},"map_3_6407":{"bounds":[5349,4646,5349,4757,5376,4757,5376,4812,5310,4812,5310,4897,5377,4897,5377,5119,5241,5119,5241,5188,5178,5188,5178,5119,3758,5119,3758,5002,3731,5002,3731,4901,3796,4901,3796,4879,3832,4879,3832,4932,3895,4932,3895,4917,3943,4917,3943,4903,4051,4903,4051,4854,4200,4854,4200,4884,4074,4884,4074,4952,4042,4952,4042,5049,4543,5049,4543,4996,4590,4996,4590,4884,4438,4884,4438,4855,4635,4855,4635,4671,4537,4671,4537,4221,4752,4221,4752,4478,4610,4478,4610,4586,4626,4586,4626,4650],"floor_z":54.69,"ceiling_z":65.3,"map":3},"map_3_8080":{"bounds":[3863,4619,3863,4755,3838,4755,3838,4879,3728,4879,3728,4768,3794,4768,3794,4622],"floor_z":54.69,"ceiling_z":57.38,"map":3},"map_3_3818":{"bounds":[5380,4814,5380,4897,5309,4897,5309,4814],"floor_z":54.69,"ceiling_z":58.72,"map":3},"map_3_2403":{"bounds":[4599,5119,4599,5585,4540,5585,4540,5549,4552,5549,4552,5121],"floor_z":54.69,"ceiling_z":57.52,"map":3},"map_2_5135":{"bounds":[4517,6397,4517,6638,4216,6638,4216,6452,4126,6452,4126,6633,3949,6633,3949,6394],"floor_z":50.7,"ceiling_z":57.3,"map":2},"map_2_1377":{"bounds":[4211,6457,4211,6554,4151,6554,4151,6481,4151,6481,4124,6481,4124,6452],"floor_z":50.7,"ceiling_z":52.5,"map":2},"map_2_6233":{"bounds":[4148,6483,4148,6591,4123,6591,4123,6483],"floor_z":50.7,"ceiling_z":58.2,"map":2},"map_2_2859":{"bounds":[5138,6369,5138,6483,5121,6483,5121,6515,5036,6515,5036,6645,4880,6645,4880,6396,5093,6396,5093,6370],"floor_z":50.45,"ceiling_z":57.4,"map":2},"map_3_8267":{"bounds":[4884,6708,4884,6757,4850,6757,4850,6708],"floor_z":50.7,"ceiling_z":57.4,"map":3},"map_3_2938":{"bounds":[3967,8035,3967,8103,3848,8103,3848,8035],"floor_z":56,"ceiling_z":60,"map":3},"map_3_1194":{"bounds":[4388,7667,4388,7918,4299,7918,4299,7667],"floor_z":53.7,"ceiling_z":58.7,"map":3},"map_3_2150":{"bounds":[4782,7220,4782,7273,4734,7273,4734,7344,4713,7344,4713,7273,4643,7273,4643,7339,4620,7339,4620,7272,4470,7272,4470,7220],"floor_z":53.7,"ceiling_z":56.9,"map":3},"map_3_9598":{"bounds":[5316,7373,5316,7551,5254,7551,5254,7816,4945,7816,4945,7221,5251,7221,5251,7377],"floor_z":53.7,"ceiling_z":62.5,"map":3},"map_3_3671":{"bounds":[4178,7156,4178,7227,4052,7227,4052,7156],"floor_z":53.7,"ceiling_z":60,"map":3},"map_3_8102":{"bounds":[4264,7272,4264,7503,4211,7503,4211,7272],"floor_z":53.7,"ceiling_z":59.7,"map":3},"map_3_2158":{"bounds":[4725,7560,4725,7920,4566,7920,4566,7560],"floor_z":53.7,"ceiling_z":59.7,"map":3},"map_4_3942":{"bounds":[4943,7221,4943,7817,4928,7817,4928,7977,4805,7977,4805,7998,4543,7998,4543,7972,4431,7972,4431,7997,4170,7997,4170,7969,4051,7969,4051,7931,4029,7931,4029,7912,3951,7912,3951,7283,4057,7283,4057,7227],"floor_z":56.9,"ceiling_z":62.5,"map":4},"map_4_8200":{"bounds":[4051,7930,4051,7989,4051,7989,4063,7989,4063,8106,3971,8106,3971,8053,4033,8053,4033,7989,3973,7989,3973,7962,3954,7962,3954,7912,4031,7912,4031,7932],"floor_z":58.2,"ceiling_z":62.5,"map":4},"map_4_8242":{"bounds":[3950,7919,3950,7963,3971,7963,3971,8105,3841,8105,3841,7921],"floor_z":58.2,"ceiling_z":61.35,"map":4},"map_4_6098":{"bounds":[4055,7224,4055,7283,3951,7283,3951,7224],"floor_z":58.2,"ceiling_z":62.5,"map":4},"map_4_1792":{"bounds":[4175,7155,4175,7223,4015,7223,4015,7155],"floor_z":58.2,"ceiling_z":61.35,"map":4},"map_4_7359":{"bounds":[4536,4852,4536,4796,4636,4796,4636,4854],"floor_z":59.95,"ceiling_z":65,"map":4},"map_4_2972":{"bounds":[4636,4855,4636,4885,4616,4885,4616,4985,4592,4985,4592,4885,4439,4885,4439,4855],"floor_z":58,"ceiling_z":65,"map":4},"map_4_9505":{"bounds":[4537,4759,4537,4854,4440,4854,4440,4884,4410,4884,4410,4970,4542,4970,4542,5050,4096,5050,4096,4970,4218,4970,4218,4881,4201,4881,4201,4853,4170,4853,4170,4777,4261,4777,4261,4759],"floor_z":58.8,"ceiling_z":65,"map":4},"map_4_8276":{"bounds":[4538,4618,4538,4758,4260,4758,4260,4776,4169,4776,4169,4852,4049,4852,4049,4904,3941,4904,3941,4755,3863,4755,3863,4616,4263,4616,4263,4641,4459,4641,4459,4619],"floor_z":57.8,"ceiling_z":65,"map":4},"map_4_3456":{"bounds":[4194,4875,4070,4875,4070,4968,4033,4968,4033,5054,4000,5054,4000,4945,4048,4945,4048,4852,4197,4852],"floor_z":57.65,"ceiling_z":65,"map":4},"map_4_4724":{"bounds":[3863,4707,3863,4900,3728,4900,3728,4768,3797,4768,3797,4709],"floor_z":58.7,"ceiling_z":61.6,"map":4},"map_5_6795":{"bounds":[5256,7377,5256,7515,5316,7515,5316,7551,5204,7551,5204,7764,4969,7764,4922,7712,4807,7712,4807,7920,4062,7920,4062,8104,3841,8104,3841,7916,3939,7916,3939,7227,4172,7227,4172,7287,4084,7287,4084,7313,4069,7313,4069,7370,4069,7638,4141,7638,4141,7453,4216,7453,4216,7287,4172,7287,4172,7272,4928,7272,4928,7225,4902,7225,4902,7185,5206,7185,5206,7379],"floor_z":62.7,"ceiling_z":69.9,"map":5},"map_5_5059":{"bounds":[4140,7432,4140,7638,4072,7638,4072,7432],"floor_z":62.7,"ceiling_z":65.4,"map":5},"map_5_5575":{"bounds":[4217,7287,4217,7451,4145,7451,4145,7431,4112,7431,4112,7365,4069,7365,4069,7311,4084,7315,4084,7285],"floor_z":62.7,"ceiling_z":69.6,"map":5},"map_5_2900":{"bounds":[4178,7156,4178,7223,4014,7223,4014,7156],"floor_z":62.7,"ceiling_z":65.4,"map":5},"map_5_3388":{"bounds":[5311,7377,5311,7512,5259,7512,5259,7377],"floor_z":62.7,"ceiling_z":66.6,"map":5},"map_3_3076":{"bounds":[4863,5420,4863,5569,4724,5569,4724,5495,4664,5495,4664,5420],"floor_z":52,"ceiling_z":57,"map":3}}],
  levelNames : [
    'Ground Floor', // Map 1
    'Level 1',      // Map 2
    'Level 2',      // Map 3
  ],
  map_dict: {
    'bl-wf01-m01-009': 'Ground Floor',
    'bl-wf01-m02-009': 'First Floor',
    'bl-wf01-m03-009': 'Second Floor',
  },
  filters: [
     
      //{ name: 'building', title: 'Building', show: true, value: '', items: [] },

    // TODO: spelling!
    // { name:'dicipline1', title:'Discipline', show:true, value:'', items:[] },

    // TODO: custom?
    // { name:'systemtype', title:'System Type', show:true, value:'', items:[] },
    { name: 'custom4', title: 'Building', show: true, value: '', items: [] },
    { name: 'level', title: 'Level', show: true, value: '', items: [] },
    //{ name: 'custom9', title: 'Parent Description', show: true, value: '', items: [] },
    
    //{ name: 'data7', title: 'Mobile / Fixed Asset', show: true, value: '', items: [] },
   { name: 'filtertop', title: 'System Type', show: true, value: '', items: [] },
    { name: 'filterside', title: 'System', show: true, value: '', items: [] },

    { name: 'atype', title: 'Asset Type', show: true, value: '', items: [] },

    // { name:'system', title:'System', show:true, value:'', items:[] },
    // { name:'subsys', title:'Sub-System', show:true, value:'', items:[] },

    // TODO: manfacturer
    // { name:'custom2', title:'Manufacturer', show:true, value:'', items:[] },

   /* {
      name: 'drawing1',
      title: 'Drawing No.',
      show: true,
      value: '',
      items: [],
    },*/

    // TODO: model
    // { name:'custom8', title:'Model', show:true, value:'', items:[] },
  ],
  // Room layer config is set via VUE_APP_ROOM_LAYER_CONFIG in the env file (see below).
  // pqs-frontend uses that env var; we also expose it as custom.roomLayerConfig for init().

  // custom datasets depending on a plant
  datasets: {
    tag: 'tag',
    atype: 'atype',
    description: 'description',
    dicipline1: 'discipline',
    room: 'room',
    level: 'level',
    custom4: 'custom4',
    model: 'model',
    manufacturer: 'manufacturer',
    system: 'system',
    subsys: 'subsys',
    serial: 'serial',
    drawing1: 'drawing1',
    drawing2: 'drawing2',
    building: 'building',
    custom12: 'room_alias',
    data7: 'data7',
    filtertop: 'system_top',
  },

  mixpanel: {
    project_token: process.env.VUE_APP_MIXPANEL_TOKEN || '[REDACTED]',
    //project_token: 'bbdbc44055174019937323fc6ed6f353',
  },
  
  mixpanel_front_events: {
    sign_in: {},
    PQView_search: {},
    Go_filter: {},
    polygon_selection: {},
    work_pack_save: {},
    work_pack_load: {},
    asset_update: {},
    new_user: {},
    show_tags: {},
    cluster_tags: {},
    path_details: {},
    navvis_iframe_clicked:{},
  },
}

// Optional: override/merge custom config from env (DEPLOY_ENV points to .env.<deployEnv>)
//   VUE_APP_CUSTOM_CONFIG='{"levelNames":["Ground Floor"],"map_dict":{"jn-m01":"Ground Floor"}}'
// Filters (dropdowns): set VUE_APP_FILTERS_CONFIG in the same env file, e.g.:
//   VUE_APP_FILTERS_CONFIG='[{"name":"custom4","title":"Building","show":true,"value":"","items":[]},{"name":"level","title":"Level","show":true,"value":"","items":[]},{"name":"atype","title":"Asset Type","show":true,"value":"","items":[]}]'
// Room layers (used by pqs-frontend): set VUE_APP_ROOM_LAYER_CONFIG in the same env file, e.g.:
//   VUE_APP_ROOM_LAYER_CONFIG='{"data8":{"label":"Filtered Mask","color":"#FFD700"},"data9":{"label":"Ear Defenders","color":"#808080"},"data10":{"label":"Additional Hi-Vis","color":"#0077CC"}}'
// Default format: { data8: { label: 'Welfare Rooms', color: '#FFD700' }, data9: { label: 'Plant Room', color: '#808080' }, ... }
function mergeCustomFromEnv(customObj, envJson) {
  if (!envJson || typeof envJson !== 'string') return
  try {
    const parsed = JSON.parse(envJson)
    if (!parsed || typeof parsed !== 'object') return
    Object.keys(parsed).forEach(function (key) {
      const envVal = parsed[key]
      if (envVal !== null && typeof envVal === 'object' && !Array.isArray(envVal) &&
          customObj[key] !== null && typeof customObj[key] === 'object' && !Array.isArray(customObj[key])) {
        customObj[key] = Object.assign({}, customObj[key], envVal)
      } else {
        customObj[key] = envVal
      }
    })
    console.log('Merged custom config from VUE_APP_CUSTOM_CONFIG')
  } catch (e) {
    console.warn('Invalid VUE_APP_CUSTOM_CONFIG JSON, using defaults:', e.message)
  }
}
mergeCustomFromEnv(custom, process.env.VUE_APP_CUSTOM_CONFIG)

// Override filters from dedicated env var (takes precedence over filters in VUE_APP_CUSTOM_CONFIG)
try {
  var filtersEnv = process.env.VUE_APP_FILTERS_CONFIG
  if (filtersEnv && typeof filtersEnv === 'string') {
    var parsedFilters = JSON.parse(filtersEnv)
    if (Array.isArray(parsedFilters)) {
      custom.filters = parsedFilters
      console.log('Filters set from VUE_APP_FILTERS_CONFIG:', custom.filters.length, 'filters')
    }
  }
} catch (e) {
  console.warn('Invalid VUE_APP_FILTERS_CONFIG JSON:', e.message)
}

// Expose room layer config for pqs-frontend (also reads VUE_APP_ROOM_LAYER_CONFIG at build time)
try {
  var roomLayerEnv = process.env.VUE_APP_ROOM_LAYER_CONFIG
  custom.roomLayerConfig = (roomLayerEnv && typeof roomLayerEnv === 'string')
    ? JSON.parse(roomLayerEnv)
    : null
} catch (e) {
  console.warn('Invalid VUE_APP_ROOM_LAYER_CONFIG JSON:', e.message)
  custom.roomLayerConfig = null
}

// False unless testing locally
let isStaticAssetUpload = process.env.VUE_APP_STATIC_ASSET_UPLOAD ?
  process.env.VUE_APP_STATIC_ASSET_UPLOAD.toLowerCase() === 'true' : false

isStaticAssetUpload = false

console.log('isStaticAssetUpload: ', isStaticAssetUpload)
let MAP_HEIGHT = process.env.MAP_HEIGHT
var MAP_WIDTH = process.env.MAP_WIDTH


// Dynamic deps generation functions
function generateDeps(assets, rooms, maps, buildings, levels) {
  const deps = {
    cp: {},
    pc: {},
  };

  // Dataset mappings (from assets.js)
  const datasets = {
    'custom19': 'drawing1',
    'custom20': 'drawing2', 
    'custom7': 'position',
    'room': 'room',
    'custom5': 'level',
    'custom4': 'building',
    'custom3': 'model',
    'custom16': 'serial',
    'custom2': 'manufacturer',
    'dicipline1': 'discipline',
    'custom17': 'system',
    'custom18': 'subsys',
    'map': 'map',  // Ensure map field is properly mapped
  };

  const ROOM_ATYPE = {
    'asrs': 1, 'building': 1, 'car park': 1, 'contractor compound': 1,
    'corridor': 1, 'external area': 1, 'laydown area': 1, 'path': 1,
    'plant': 1, 'road': 1, 'roof area': 1, 'room': 1, 'storage': 1,
    'tank farm': 1, 'void': 1, 'room/area': 1,
  };

  // Relationship definitions
  const relate = [
    {pc:true, p:'room',c:'asset',exclude:(row)=>row.room$},
    {pc:true, p:'map',c:'building'},
    {pc:true, p:'building',c:'level'},
    {pc:true, p:'building',c:'map'},
    {pc:true, p:'map~building',c:'level'},
    {pc:true, p:'map~building~level',c:'room',include:(row)=>row.room$},
    {pc:true, p:'building~level',c:'map'},
    {pc:true, p:'map~level',c:'level', include:(row)=>row.map},
    {cp:true, p:'map~building~level',c:'room'},
    {cp:true, p:'room',c:'asset', exclude:(row)=>row.room$},
  ];

  // Convert assets array back to objects and apply transformations
  let assetObjects = [];
  if (assets && assets.length > 0) {
    // Check if assets is already an array of objects (from API)
    if (typeof assets[0] === 'object' && !Array.isArray(assets[0])) {
      // Assets are already objects, use them directly
      assetObjects = assets.map(item => {
        // Ensure all values are strings and trimmed
        const processedItem = {};
        for (let key in item) {
          const value = item[key];
          // Convert null/undefined to empty string instead of string "null"/"undefined"
          if (value === null || value === undefined) {
            processedItem[key] = '';
          } else {
            const strValue = ('' + value).trim();
            // Also convert string "null", "undefined", "NaN" to empty string
            if (strValue === 'null' || strValue === 'undefined' || strValue === 'NaN') {
              processedItem[key] = '';
            } else {
              processedItem[key] = strValue;
            }
          }
        }
        return processedItem;
      });
    } else if (Array.isArray(assets[0])) {
      // Assets are in CSV-like format [headers, ...rows]
      const [headers, ...assetRows] = assets;
      if (Array.isArray(headers)) {
        assetObjects = assetRows.map(row => {
          const item = {};
          headers.forEach((header, index) => {
            const value = row[index];
            // Convert null/undefined to empty string instead of string "null"/"undefined"
            if (value === null || value === undefined) {
              item[header] = '';
            } else {
              const strValue = ('' + value).trim();
              // Also convert string "null", "undefined", "NaN" to empty string
              if (strValue === 'null' || strValue === 'undefined' || strValue === 'NaN') {
                item[header] = '';
              } else {
                item[header] = strValue;
              }
            }
          });
          return item;
        });
      }
    }
    
    // Apply dataset transformations and processing to all assetObjects
    assetObjects = assetObjects.map(item => {

      // Apply dataset transformations (CRITICAL!)
      for(let field in datasets) {
        if (item[field] !== undefined) {
          item[datasets[field]] = (''+item[field]).trim();
        }
      }

      // Ensure map field has a valid value to prevent "Mnull" issue
      
      if (!item.map) {
        // Only use numeric map values, don't create building-based maps
        // Try to extract numeric map from level if it's in M# format
        if (item.level && /^M\d+$/.test(item.level)) {
          item.map = item.level.substring(1); // Extract number from M1, M2, etc.
        } else if (item.level && /^\d+$/.test(item.level)) {
          item.map = item.level; // Use level if it's already numeric
        } else {
          item.map = '4'; // Default to map 1 instead of building-based names
        }
        console.warn(`Asset ${item.tag || item.id} missing map data, using: ${item.map}`);
      }

      // When an asset has no level, use its map value as the level so that
      // the map~level dep keys are unique per map and filterAssets works correctly.
      if ((!item.level || item.level === '' || item.level === 'null') && item.map) {
        item.level = item.map;
      }

      // Set ID correctly (CRITICAL!)
      item.id = item.data4 || item.id; // Use data4 if available, fallback to existing id
      
      // Convert coordinates
      item['xco'] = item['xco'] ? +item['xco'] : 0;
      item['yco'] = item['yco'] ? +item['yco'] : 0;
      item['zco'] = item['zco'] ? +item['zco'] : 0;

      // Process polygons for room types
      if(ROOM_ATYPE[item.atype?.toLowerCase()] =='room/area') {
        item = processPolygon(item);
      }
     

      item.$preset = true;
      return item;
    });
  }

  // Combine all data sources
  const allRows = [...assetObjects, ...(rooms || [])];
  
  console.log('Building relationships from', allRows.length, 'rows');
  console.log('Sample rows with room$ property:', allRows.filter(r => r.room$).slice(0, 3));
  console.log('Sample regular rows:', allRows.filter(r => !r.room$).slice(0, 3));

  // Build relationships (same as before)
  allRows.forEach(row => {
    relate.forEach(r => {
      // Build Child-to-Parent
      if(r.cp && (!r.exclude || !r.exclude(row)) && (!r.include || r.include(row))) {
        const pv = makeParentVal(r, row);
        deps.cp[r.c] = deps.cp[r.c] || {};
        deps.cp[r.c][row[r.c]] = pv;
      }

      // Build Parent-to-Child
      if(r.pc && (!r.exclude || !r.exclude(row)) && (!r.include || r.include(row))) {
        const pk = makeParentKey(r, row);
        
        // Debug specific relationship
        if (r.p === 'map~building~level') {
          console.log('Building map~building~level relationship:', {
            parentKey: pk,
            child: r.c,
            childId: makeChildId(r, row),
            row: { map: row.map, building: row.building, level: row.level, room: row.room, hasRoom$: !!row.room$ }
          });
        }
        
        deps.pc[r.p] = deps.pc[r.p] || {};
        deps.pc[r.p][pk] = deps.pc[r.p][pk] || {};
        deps.pc[r.p][pk][r.c] = deps.pc[r.p][pk][r.c] || [];
        
        const cid = makeChildId(r, row);
        insertChild(deps.pc[r.p][pk][r.c], cid);
      }
    });
  });

  return deps;
}

// Add polygon processing function
function processPolygon(item) {
  let poly = [];
  
  // Use existing polygon data from API if available
  if (item.poly && Array.isArray(item.poly) && item.poly.length > 0) {
    poly = item.poly;
    console.log('Using existing polygon data for', item.tag || item.name, ':', poly.length, 'points');
  } else if (item.data2) {
    // Fallback to parsing data2 only if poly doesn't exist
    const MAP_HEIGHT = parseInt(process.env.VUE_APP_MAP_HEIGHT) || 6144;
    let coords = item.data2.split(/\s*-\s*/).filter(c=>''!=c&&'#N/A'!=c);
    
    if(coords.length > 0) {
      for(var cI = 0; cI < coords.length-1; cI+=2) {
        if(''!=coords[cI]&&''!=coords[cI+1]) {
          poly.push([MAP_HEIGHT-Math.round(coords[cI+1]),Math.round(coords[cI])]);
        }
      }
    }
    console.log('Parsed polygon data from data2 for', item.tag || item.name, ':', poly.length, 'points');
  } else {
    console.warning('No polygon data found for', item.tag || item.name);
  }
  
  if(poly.length > 0) {
    item.room$ = {
      id: item.data4 || item.id,
      name: item.tag || item.name,
      room: item.room,
      xco: item.xco,
      yco: item.yco,
      zco: item.zco,
      map: item.map,
      area: item.data5 || item.area,
      level: item.level,
      building: item.building,
      desc: item.description || item.desc,
      poly: poly,
      level_id: item.data6,
      showlabel: item.data5 || item.area,
      row: item.row,
    };
  }
  return item;
}

// Helper functions
function makeParentKey(relate, row) {
  return relate.p.split(/~/g).map(pn => row[pn] || '').join('~');
}

function makeParentVal(relate, row) {
  return relate.p.split(/~/g).reduce((a, pn) => (a[pn] = row[pn] || '', a), {});
}

function makeChildId(relate, row) {
  return row[relate.c];
}

function insertChild(arr, child) {
  if (!child) return;
  
  for(let i = 0; i < arr.length; i++) {
    if(('~'+arr[i]) === ('~'+child)) {
      return;
    }
    else if(('~'+arr[i]) > ('~'+child)) {
      arr.splice(i, 0, child);
      return;
    }
  }
  arr.push(child);
}

// Helper function to extract buildings from deps
function extractBuildingsFromDeps(deps) {
  const buildings = new Set();
  
  // Function to validate if a building name is valid
  const isValidBuildingName = (buildingName) => {
    if (!buildingName || typeof buildingName !== 'string') return false;
    const trimmed = buildingName.trim();
    
    // Filter out invalid values
    const invalidValues = [
      '', 'null', 'undefined', 'custom4val', 'custom4', 
      'NaN', 'false', 'true', '0', 'N/A', '#N/A', 
      'none', 'None', 'NONE', 'TBD', 'tbd'
    ];
    
    // Check if it's in the invalid list (case insensitive)
    if (invalidValues.some(invalid => invalid.toLowerCase() === trimmed.toLowerCase())) {
      return false;
    }
    
    // Filter out values that look like field names (contain 'custom' or 'data')
    if (trimmed.toLowerCase().includes('custom') || trimmed.toLowerCase().includes('data')) {
      return false;
    }
    
    // Must be at least 2 characters and not just numbers
    if (trimmed.length < 2 || /^\d+$/.test(trimmed)) {
      return false;
    }
    
    return true;
  };
  
  // Extract from parent-child relationships
  if (deps.pc && deps.pc.building) {
    // Get all building keys from deps.pc.building
    Object.keys(deps.pc.building).forEach(buildingName => {
      if (isValidBuildingName(buildingName)) {
        console.log('Adding building:', buildingName);
        //buildings.add(buildingName.trim());
      }
    });
  }
  
  // Extract from map~building relationships if they exist
  if (deps.pc && deps.pc['map~building']) {
    Object.keys(deps.pc['map~building']).forEach(mapBuilding => {
      // mapBuilding format is "map~building"
      const parts = mapBuilding.split('~');
      if (parts.length >= 2 && isValidBuildingName(parts[1])) {
        buildings.add(parts[1].trim());
      }
    });
  }
  
  // Extract from child-parent relationships
  if (deps.cp && deps.cp.building) {
    Object.keys(deps.cp.building).forEach(buildingName => {
      if (isValidBuildingName(buildingName)) {
        buildings.add(buildingName.trim());
      }
    });
  }
  
  // Convert Set to sorted array
  return Array.from(buildings).sort();
}

// Helper function to extract levels from deps
function extractLevelsFromDeps(deps) {
  const levels = new Set();
  
  // Valid level pattern: M followed by a number (M1, M2, M3, etc.)
  const isValidLevel = (levelName) => {
    if (!levelName || typeof levelName !== 'string') return false;
    const trimmed = levelName.trim();
    // Match M followed by one or more digits
    return /^M\d+$/.test(trimmed);
  };
  
  if (deps.pc && deps.pc.level) {
    Object.keys(deps.pc.level).forEach(levelName => {
      if (isValidLevel(levelName)) {
        levels.add(levelName.trim());
      }
    });
  }
  
  // Extract from composite keys like "building~level" or "map~building~level"
  Object.keys(deps.pc || {}).forEach(parentKey => {
    if (parentKey.includes('level')) {
      Object.keys(deps.pc[parentKey]).forEach(compositeKey => {
        const parts = compositeKey.split('~');
        // Find the level part (usually the last part in building~level or map~building~level)
        const levelIndex = parentKey.split('~').indexOf('level');
        if (levelIndex >= 0 && parts[levelIndex]) {
          const levelName = parts[levelIndex].trim();
          if (isValidLevel(levelName)) {
            levels.add(levelName);
          }
        }
      });
    }
  });
  
  // Sort levels numerically (M1, M2, M3, etc.)
  return Array.from(levels).sort((a, b) => {
    const numA = parseInt(a.substring(1));
    const numB = parseInt(b.substring(1));
    return numA - numB;
  });
}

// Helper function to extract maps directly from assets
function extractMapsFromAssets(assets) {
  const maps = new Set();
  
  // Function to validate if a map value is valid
  const isValidMapValue = (mapValue) => {
    if (mapValue === null || mapValue === undefined) return false;
    
    const mapStr = String(mapValue).trim();
    
    // Filter out invalid values
    const invalidValues = [
      '', 'null', 'undefined', 'Mnull', 'null~', '~null',
      'NaN', 'false', 'true', 'N/A', '#N/A', 
      'none', 'None', 'NONE', 'TBD', 'tbd'
    ];
    
    // Check if it's in the invalid list (case insensitive)
    if (invalidValues.some(invalid => invalid.toLowerCase() === mapStr.toLowerCase())) {
      return false;
    }
    
    // Filter out values that contain 'null'
    if (mapStr.toLowerCase().includes('null')) {
      return false;
    }
    
    // Must be at least 1 character
    if (mapStr.length < 1) {
      return false;
    }
    
    // Only accept numeric map values (1, 2, 3, etc.) or M-prefixed levels (M1, M2, M3, etc.)
    // Reject building names and other non-map identifiers
    const isNumeric = /^\d+$/.test(mapStr);
    const isMLevel = /^M\d+$/.test(mapStr);
    
    // Reject if it looks like a building name (contains letters but not in M# format)
    const hasLetters = /[a-zA-Z]/.test(mapStr);
    const isBuildingName = hasLetters && !isMLevel;
    
    if (isBuildingName) {
      return false;
    }
    
    return isNumeric || isMLevel;
  };
  
  // Extract maps directly from asset data
  if (assets && Array.isArray(assets)) {
    console.log(`Processing ${assets.length} assets for map extraction`);
    let validMaps = 0;
    let invalidMaps = 0;
    
    assets.forEach((asset, index) => {
      if (asset && typeof asset === 'object') {
        // Debug: Show all map values being processed
        if (index < 10) {
          console.log(`Asset ${index}: ${asset.tag || asset.id} -> map: "${asset.map}" (type: ${typeof asset.map})`);
        }
        
        if (isValidMapValue(asset.map)) {
          maps.add(String(asset.map).trim());
          validMaps++;
          
          // Debug: Show first few valid maps
          if (validMaps <= 5) {
            console.log(`✅ VALID MAP: Asset ${index}: ${asset.tag || asset.id} -> map: "${asset.map}"`);
          }
        } else {
          invalidMaps++;
          // Debug: Show first few invalid maps
          if (invalidMaps <= 10) {
            console.log(`❌ INVALID MAP: Asset ${index}: ${asset.tag || asset.id} -> map: "${asset.map}"`);
          }
        }
      }
    });
    
    console.log(`Map extraction: ${validMaps} valid, ${invalidMaps} invalid, ${maps.size} unique maps found`);
    console.log('All extracted maps:', Array.from(maps));
    
    // Debug: Show what types of maps we found
    const mapArray = Array.from(maps);
    const numericMaps = mapArray.filter(map => /^\d+$/.test(map));
    const mLevelMaps = mapArray.filter(map => /^M\d+$/.test(map));
    const otherMaps = mapArray.filter(map => !/^\d+$/.test(map) && !/^M\d+$/.test(map));
    
    console.log('Numeric maps:', numericMaps);
    console.log('M-level maps:', mLevelMaps);
    console.log('Other maps (should be empty):', otherMaps);
  }
  
  // Sort maps properly - handle both numeric maps and M-prefixed levels
  const mapArray = Array.from(maps);
  
  return mapArray.sort((a, b) => {
    // Handle numeric maps (1, 2, 3, etc.)
    const aIsNumeric = /^\d+$/.test(a);
    const bIsNumeric = /^\d+$/.test(b);
    
    if (aIsNumeric && bIsNumeric) {
      return parseInt(a) - parseInt(b);
    }
    
    // Handle M-prefixed levels (M1, M2, M3, etc.)
    const aIsMLevel = /^M\d+$/.test(a);
    const bIsMLevel = /^M\d+$/.test(b);
    
    if (aIsMLevel && bIsMLevel) {
      const aNum = parseInt(a.substring(1));
      const bNum = parseInt(b.substring(1));
      return aNum - bNum;
    }
    
    // Mixed types: put numeric maps first, then M-levels
    if (aIsNumeric && bIsMLevel) return -1;
    if (aIsMLevel && bIsNumeric) return 1;
    
    // Fallback to alphabetical
    return a.localeCompare(b);
  });
}


console.log('APP: demwa01', 'map:009', 'data:009a', info, model, td, isStaticAssetUpload)

//bl-wf01-m01-001
function initPlantQuest() {
  console.log('APP: demwa01', 'map:009', 'data:009a', info, model, td, isStaticAssetUpload);

  init({
    info,
    aws,
    custom,
    td,
    model,
    VUE_APP_CLOUDFRONT_DISTRIBUTION: process.env.VUE_APP_CLOUDFRONT_DISTRIBUTION || "",
    upload: isStaticAssetUpload,
    
    map: {
      prefix: process.env.VUE_APP_MAP_PREFIX,
      suffix: process.env.VUE_APP_MAP_SUFFIX,
      width: parseInt(process.env.VUE_APP_MAP_WIDTH),
      height: parseInt(process.env.VUE_APP_MAP_HEIGHT),
      minZoom: parseInt(process.env.VUE_APP_MAP_MIN_ZOOM),
      maxZoom: parseInt(process.env.VUE_APP_MAP_MAX_ZOOM),
      zoom: parseInt(process.env.VUE_APP_MAP_ZOOM)
    },
    levelNames: {
      test: 'Level 1',
    },
    kinde: {
      client_id: process.env.VUE_APP_KINDE_CLIENT_ID,
      domain: process.env.VUE_APP_KINDE_DOMAIN
    },
    seneca: {
      endpoint: (msg) => {
        let isPublic = ('web' === msg.aim &&
                        ('auth' === msg.on || 'user' === msg.signin))

        let prepath = '/api'
        let suffix = prepath + (isPublic ? '/public/auth' : '/private/' + (msg.on || 'msg01'))
        
        let url = document.location.origin + suffix
      
        console.log('ENDPOINT', isPublic, url, msg)
        
        return url
      }
    },
  });
}